<% if (specialHours.length) { %>
<div class="address-availability__special-hours">
  <h3 class="address-availability__special-hours-title"><%= title %></h3>
  <ul class="address-availability__special-hours-text">
      <% _.each(specialHours, function(hour) { %>
        <li class="hour"><%= hour.name %>  &ndash; <%= hour.text %></li>
      <% }) %>
  </ul>
</div>
<% } %>
